import React from 'react';

import { blueBlack630 } from '../../../../theme/videa-style-tokens';

const KeyboardIcon = () => (
  <svg
    width="42"
    height="20"
    viewBox="0 0 42 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="keyboard-icon"
  >
    <path
      d="M10.5161 14.4817C10.5161 14.4817 10.2763 14.4817 10.2763 14.7211V16.8023C10.2763 16.8023 10.2763 17.0421 10.5161 17.0421H31.8542C31.8542 17.0421 32.094 17.0421 32.094 16.8023V14.7211C32.094 14.7211 32.094 14.4817 31.8542 14.4817H10.5161Z"
      fill={blueBlack630}
    />
    <path
      d="M33.6138 14.4817C33.6138 14.4817 33.374 14.4817 33.374 14.7211V16.8023C33.374 16.8023 33.374 17.0421 33.6138 17.0421H39.1091C39.1091 17.0421 39.3489 17.0421 39.3489 16.8023V14.7211C39.3489 14.7211 39.3489 14.4817 39.1091 14.4817H33.6138Z"
      fill={blueBlack630}
    />
    <path
      d="M3.31188 14.4817C3.31188 14.4817 3.07208 14.4817 3.07208 14.7211V16.8023C3.07208 16.8023 3.07208 17.0421 3.31188 17.0421H8.8072C8.8072 17.0421 9.04699 17.0421 9.04699 16.8023V14.7211C9.04699 14.7211 9.04699 14.4817 8.8072 14.4817H3.31188Z"
      fill={blueBlack630}
    />
    <path
      d="M14.4084 10.6406C14.4084 10.6406 14.1689 10.6406 14.1689 10.8801V12.9612C14.1689 12.9612 14.1689 13.201 14.4084 13.201H16.4896C16.4896 13.201 16.7294 13.201 16.7294 12.9612V10.8801C16.7294 10.8801 16.7294 10.6406 16.4896 10.6406H14.4084Z"
      fill={blueBlack630}
    />
    <path
      d="M10.5671 10.6406C10.5671 10.6406 10.3273 10.6406 10.3273 10.8801V12.9612C10.3273 12.9612 10.3273 13.201 10.5671 13.201H12.6483C12.6483 13.201 12.8877 13.201 12.8877 12.9612V10.8801C12.8877 10.8801 12.8877 10.6406 12.6483 10.6406H10.5671Z"
      fill={blueBlack630}
    />
    <path
      d="M3.31188 10.6406C3.31188 10.6406 3.07208 10.6406 3.07208 10.8801V12.9612C3.07208 12.9612 3.07208 13.201 3.31188 13.201H8.8072C8.8072 13.201 9.04699 13.201 9.04699 12.9612V10.8801C9.04699 10.8801 9.04699 10.6406 8.8072 10.6406H3.31188Z"
      fill={blueBlack630}
    />
    <path
      d="M18.2495 10.6406C18.2495 10.6406 18.0097 10.6406 18.0097 10.8801V12.9612C18.0097 12.9612 18.0097 13.201 18.2495 13.201H20.3307C20.3307 13.201 20.5701 13.201 20.5701 12.9612V10.8801C20.5701 10.8801 20.5701 10.6406 20.3307 10.6406H18.2495Z"
      fill={blueBlack630}
    />
    <path
      d="M22.0906 10.6406C22.0906 10.6406 21.8512 10.6406 21.8512 10.8801V12.9612C21.8512 12.9612 21.8512 13.201 22.0906 13.201H24.1718C24.1718 13.201 24.4116 13.201 24.4116 12.9612V10.8801C24.4116 10.8801 24.4116 10.6406 24.1718 10.6406H22.0906Z"
      fill={blueBlack630}
    />
    <path
      d="M25.9314 10.6406C25.9314 10.6406 25.6917 10.6406 25.6917 10.8801V12.9612C25.6917 12.9612 25.6917 13.201 25.9314 13.201H28.0126C28.0126 13.201 28.2521 13.201 28.2521 12.9612V10.8801C28.2521 10.8801 28.2521 10.6406 28.0126 10.6406H25.9314Z"
      fill={blueBlack630}
    />
    <path
      d="M29.7726 10.6406C29.7726 10.6406 29.5332 10.6406 29.5332 10.8801V12.9612C29.5332 12.9612 29.5332 13.201 29.7726 13.201H31.8538C31.8538 13.201 32.0936 13.201 32.0936 12.9612V10.8801C32.0936 10.8801 32.0936 10.6406 31.8538 10.6406H29.7726Z"
      fill={blueBlack630}
    />
    <path
      d="M33.6138 10.6406C33.6138 10.6406 33.374 10.6406 33.374 10.8801V12.9612C33.374 12.9612 33.374 13.201 33.6138 13.201H39.1606C39.1606 13.201 39.4 13.201 39.4 12.9612V10.8801C39.4 10.8801 39.4 10.6406 39.1606 10.6406H33.6138Z"
      fill={blueBlack630}
    />
    <path
      d="M12.7013 6.79932C12.7013 6.79932 12.4615 6.79932 12.4615 7.03874V9.11993C12.4615 9.11993 12.4615 9.35973 12.7013 9.35973H14.7825C14.7825 9.35973 15.0223 9.35973 15.0223 9.11993V7.03874C15.0223 7.03874 15.0223 6.79932 14.7825 6.79932H12.7013Z"
      fill={blueBlack630}
    />
    <path
      d="M8.8601 6.79932C8.8601 6.79932 8.6203 6.79932 8.6203 7.03874V9.11993C8.6203 9.11993 8.6203 9.35973 8.8601 9.35973H10.9413C10.9413 9.35973 11.1811 9.35973 11.1811 9.11993V7.03874C11.1811 7.03874 11.1811 6.79932 10.9413 6.79932H8.8601Z"
      fill={blueBlack630}
    />
    <path
      d="M3.31188 6.79932C3.31188 6.79932 3.07208 6.79932 3.07208 7.03874V9.11993C3.07208 9.11993 3.07208 9.35973 3.31188 9.35973H7.10013C7.10013 9.35973 7.33993 9.35973 7.33993 9.11993V7.03874C7.33993 7.03874 7.33993 6.79932 7.10013 6.79932H3.31188Z"
      fill={blueBlack630}
    />
    <path
      d="M16.542 6.79932C16.542 6.79932 16.3022 6.79932 16.3022 7.03874V9.11993C16.3022 9.11993 16.3022 9.35973 16.542 9.35973H18.6232C18.6232 9.35973 18.863 9.35973 18.863 9.11993V7.03874C18.863 7.03874 18.863 6.79932 18.6232 6.79932H16.542Z"
      fill={blueBlack630}
    />
    <path
      d="M20.3832 6.79932C20.3832 6.79932 20.1438 6.79932 20.1438 7.03874V9.11993C20.1438 9.11993 20.1438 9.35973 20.3832 9.35973H22.4644C22.4644 9.35973 22.7042 9.35973 22.7042 9.11993V7.03874C22.7042 7.03874 22.7042 6.79932 22.4644 6.79932H20.3832Z"
      fill={blueBlack630}
    />
    <path
      d="M24.2244 6.79932C24.2244 6.79932 23.9846 6.79932 23.9846 7.03874V9.11993C23.9846 9.11993 23.9846 9.35973 24.2244 9.35973H26.3056C26.3056 9.35973 26.545 9.35973 26.545 9.11993V7.03874C26.545 7.03874 26.545 6.79932 26.3056 6.79932H24.2244Z"
      fill={blueBlack630}
    />
    <path
      d="M28.0655 6.79932C28.0655 6.79932 27.8261 6.79932 27.8261 7.03874V9.11993C27.8261 9.11993 27.8261 9.35973 28.0655 9.35973H30.1467C30.1467 9.35973 30.3865 9.35973 30.3865 9.11993V7.03874C30.3865 7.03874 30.3865 6.79932 30.1467 6.79932H28.0655Z"
      fill={blueBlack630}
    />
    <path
      d="M31.9067 6.79932C31.9067 6.79932 31.6669 6.79932 31.6669 7.03874V9.11993C31.6669 9.11993 31.6669 9.35973 31.9067 9.35973H33.9879C33.9879 9.35973 34.2273 9.35973 34.2273 9.11993V7.03874C34.2273 7.03874 34.2273 6.79932 33.9879 6.79932H31.9067Z"
      fill={blueBlack630}
    />
    <path
      d="M35.7479 6.79932C35.7479 6.79932 35.5085 6.79932 35.5085 7.03874V9.11993C35.5085 9.11993 35.5085 9.35973 35.7479 9.35973H39.1606C39.1606 9.35973 39.4004 9.35973 39.4004 9.11993V7.03874C39.4004 7.03874 39.4004 6.79932 39.1606 6.79932H35.7479Z"
      fill={blueBlack630}
    />
    <path
      d="M21.9955 2.95776C21.9955 2.95776 21.7561 2.95776 21.7561 3.19756V5.27875C21.7561 5.27875 21.7561 5.51854 21.9955 5.51854H24.0771C24.0771 5.51854 24.3165 5.51854 24.3165 5.27875V3.19756C24.3165 3.19756 24.3165 2.95776 24.0771 2.95776H21.9955Z"
      fill={blueBlack630}
    />
    <path
      d="M18.2587 2.95776C18.2587 2.95776 18.0193 2.95776 18.0193 3.19756V5.27875C18.0193 5.27875 18.0193 5.51854 18.2587 5.51854H20.3403C20.3403 5.51854 20.5797 5.51854 20.5797 5.27875V3.19756C20.5797 3.19756 20.5797 2.95776 20.3403 2.95776H18.2587Z"
      fill={blueBlack630}
    />
    <path
      d="M14.5219 2.95776C14.5219 2.95776 14.2821 2.95776 14.2821 3.19756V5.27875C14.2821 5.27875 14.2821 5.51854 14.5219 5.51854H16.6031C16.6031 5.51854 16.8425 5.51854 16.8425 5.27875V3.19756C16.8425 3.19756 16.8425 2.95776 16.6031 2.95776H14.5219Z"
      fill={blueBlack630}
    />
    <path
      d="M10.7855 2.95776C10.7855 2.95776 10.5457 2.95776 10.5457 3.19756V5.27875C10.5457 5.27875 10.5457 5.51854 10.7855 5.51854H12.8667C12.8667 5.51854 13.1061 5.51854 13.1061 5.27875V3.19756C13.1061 3.19756 13.1061 2.95776 12.8667 2.95776H10.7855Z"
      fill={blueBlack630}
    />
    <path
      d="M7.04869 2.95776C7.04869 2.95776 6.8089 2.95776 6.8089 3.19756V5.27875C6.8089 5.27875 6.8089 5.51854 7.04869 5.51854H9.12988C9.12988 5.51854 9.36968 5.51854 9.36968 5.27875V3.19756C9.36968 3.19756 9.36968 2.95776 9.12988 2.95776H7.04869Z"
      fill={blueBlack630}
    />
    <path
      d="M3.31188 2.95776C3.31188 2.95776 3.07208 2.95776 3.07208 3.19756V5.27875C3.07208 5.27875 3.07208 5.51854 3.31188 5.51854H5.39307C5.39307 5.51854 5.63286 5.51854 5.63286 5.27875V3.19756C5.63286 3.19756 5.63286 2.95776 5.39307 2.95776H3.31188Z"
      fill={blueBlack630}
    />
    <path
      d="M25.7324 2.95776C25.7324 2.95776 25.493 2.95776 25.493 3.19756V5.27875C25.493 5.27875 25.493 5.51854 25.7324 5.51854H27.8136C27.8136 5.51854 28.0534 5.51854 28.0534 5.27875V3.19756C28.0534 3.19756 28.0534 2.95776 27.8136 2.95776H25.7324Z"
      fill={blueBlack630}
    />
    <path
      d="M29.4696 2.95776C29.4696 2.95776 29.2298 2.95776 29.2298 3.19756V5.27875C29.2298 5.27875 29.2298 5.51854 29.4696 5.51854H31.5504C31.5504 5.51854 31.7902 5.51854 31.7902 5.27875V3.19756C31.7902 3.19756 31.7902 2.95776 31.5504 2.95776H29.4696Z"
      fill={blueBlack630}
    />
    <path
      d="M33.2064 2.95776C33.2064 2.95776 32.9666 2.95776 32.9666 3.19756V5.27875C32.9666 5.27875 32.9666 5.51854 33.2064 5.51854H35.2872C35.2872 5.51854 35.527 5.51854 35.527 5.27875V3.19756C35.527 3.19756 35.527 2.95776 35.2872 2.95776H33.2064Z"
      fill={blueBlack630}
    />
    <path
      d="M36.9428 2.95776C36.9428 2.95776 36.703 2.95776 36.703 3.19756V5.27875C36.703 5.27875 36.703 5.51854 36.9428 5.51854H39.024C39.024 5.51854 39.2634 5.51854 39.2634 5.27875V3.19756C39.2634 3.19756 39.2634 2.95776 39.024 2.95776H36.9428Z"
      fill={blueBlack630}
    />
  </svg>
);

export default KeyboardIcon;
